import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { EmptyRecRepFilter, Filter, IRecRepFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { AutoFillTimeSheet } from "./AutoFillTimeSheet";
import { PendingTimesheetsList } from "./PendingTimesheetsList";

interface ITimeSheetReport {
    login_ID?: number,
    recruiter?: string,
    branchName?: string,
    allReq?: number,
    onsite?: number,
    hybrid?: number,
    remote?: number,
    serve?: number,
    unServe?: number,
    submittal?: number,
    eci?: number,
    po?: number
}
interface IProps {
    // setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    // permissions: IPermissionProps,
    // byConsultant: number,
    po: IPurchaseOrder,
}

export const ConsultantTimeSheetReport = (props: IProps) => {
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);
    const [salEffFilter, setSalEffFilter] = useState<IRecRepFilter>(EmptyRecRepFilter);
    const [historytableData, setHistorytableData] = useState({ historytableData: [], loading: false } as { historytableData: Array<any>, loading: boolean });
    const [timesheetLeft, setTimesheetLeft] = useState<number>(0);
    const [autoFillTimesheet, setAutoFillTimesheet] = useState({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 } as { singleData: any, open: boolean, po: any, recent: any, timeSheetCount: number });
    const [openPedingTimesheets, setOpenPedingTimesheets] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [tableLoad, setTableLoad] = useState(false);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Pending Consultant Timesheets Report</h5>
        </div>
    );

    const hideAutoFilltTimesheetDialog = () => { setAutoFillTimesheet({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 }); };



    const loadTableData1 = async () => {
        setHistorytableData({ historytableData: historytableData.historytableData, loading: true });
        const response = await Fetch("Report_Timesheet/getConsultantTimesheetLeft", "GET", null, `filter=${JSON.stringify(salEffFilter)}`, null);
        if (response) {
            const data = await response.json();
            setTimesheetLeft(data.timesheetLeft);
            setHistorytableData({
                historytableData: data.consultantTimesheetsLeft.map((rowData: any) => {
                    return {
                        ...rowData,
                        salesmanager: (rowData.salesmanager || "")
                            .split(",")
                            .map((ele: string) => ele.split("-")[0].trim())
                            .join(", "),
                        user_Name: (rowData.user_Name || "")
                            .split(",")
                            .map((ele: string) => ele.split("-")[0].trim())
                            .join(", ")
                    };
                }),
                loading: false
            });

        } else {
            setHistorytableData({ historytableData: historytableData.historytableData, loading: false });
        }
    }

    const sendMail = async (data: any) => {
        const response = await Fetch('Report_Timesheet/mail', 'POST', null, `consultant_id=${data.consultant_ID}&Recruiter_ID=${data.recruiter_ID}`, null);
        if (response) {
            toast.current.show({ severity: 'success', detail: 'Mail sent successfully to consultant.', life: 3000 });
        }
    };

    const rejectFunc = () => {
        toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }
    const confirmSendMail = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to send an email to ${rowData.consultantName}?`,
            header: 'Send Email Confirmation',
            icon: 'pi pi-envelope',
            acceptClassName: 'p-button-success',
            rejectClassName: 'p-button-secondary',
            acceptLabel: 'Yes, Send',
            rejectLabel: 'Cancel',
            accept: () => sendMail(rowData),
            reject: () => rejectFunc()
        });
    };



    const sendCompanyDetail = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-envelope" className="p-button-rounded  p-button-text ml-2" onClick={() => confirmSendMail(rowData)} tooltip="Send an email to the consultant" />
            </>
        )
    }

    const getPendingTimesheetLeft = (rowData: any) => {
        return (
            <>
                {/* <Tooltip target=".tooltip-item" position="top" /> */}
                <div className="flex w-full">
                    <div className="flex w-25rem">{timesheetLeft !== 0 && <h1 className="flex text-2xl font-bold mr-5 hover:text-blue-700 hover:underline" style={{ cursor: "pointer" }} onClick={() => {
                        // setAutoFillTimesheet({ open: true, singleData: { consultant_ID: rowData.consultant_ID, pO_ID: rowData.pO_ID }, po: props.po, recent: rowData, timeSheetCount: rowData.timesheetsLeft });
                        setOpenPedingTimesheets({ open: true, singleData: rowData });
                    }}><span data-pr-tooltip="Click to view pending timesheets details" style={{ color: 'red' }}>{rowData.timesheetsLeft}</span></h1>}</div>
                </div>
            </>
        );
    };



    console.log(autoFillTimesheet)
    useEffect(() => {
        if (tableLoad) {
            loadTableData1();
            setTableLoad(false)
        }
    }, [salEffFilter]);

    return (
        <>
            <Toolbar className="mb-1 py-0" ></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter salEffFilter={salEffFilter} setSalEffFilter={setSalEffFilter} onSearch={() => setTableLoad(true)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                header={header}
                emptyMessage="No Branches found."
                loading={historytableData.loading}
                value={historytableData.historytableData}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultantName" header="Consultant Name" />
                <Column field="salesmanager" header="Sales Manager" />
                <Column field="sales_Company_Branch" header="Sales Comp (Branch)" sortable />
                <Column field="user_Name" header="Recruiter" />
                <Column field="recruiter_Company_Branch" header="Recruiter Comp (Branch)" sortable />
                <Column field="timesheetsLeft" header="Timesheets Left" body={getPendingTimesheetLeft} />
                <Column field="" header="Send Mail" body={sendCompanyDetail} />
            </DataTable>
            <ConfirmDialog />
            <Toast ref={toast} />
            <AutoFillTimeSheet singleData={autoFillTimesheet.singleData} open={autoFillTimesheet.open} hideDialog={hideAutoFilltTimesheetDialog} toast={props.toast} setReload={props.setReload} po={props?.po} recent={autoFillTimesheet.recent} timeSheetCount={autoFillTimesheet.timeSheetCount} reloadDialog={() => {
                loadTableData1();
                // GetTimesheetLeft();
            }} filter={salEffFilter} />
            <PendingTimesheetsList open={openPedingTimesheets.open} singleData={openPedingTimesheets.singleData} hideDialog={() => setOpenPedingTimesheets({ open: false, singleData: {} })} />
        </>
    );
}
